import { RootState } from '../../../applicationStore';
import { SupplierState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getSupplierState = (state: RootState): SupplierState =>
  state.supplier;

export const getSupplierLoader = createSelector(
  getSupplierState,
  (state): boolean => state.loading,
);

export const getSupplierData = createSelector(
  getSupplierState,
  (state): SupplierState['data'] | null => state?.data || null,
);
